import { EMPTY_VALUE_PLACEHOLDER } from '../../../const/system';
import { FEATURES_SOURCE_MAP } from '../pages/PageFeatures/PageFeatures.const';
import { SOURCES_MAP } from '../../../const/sources';



const getFeatureSourceTranslation = (source) => {
  switch (source) {
    case FEATURES_SOURCE_MAP.DAILY: return 'features-breadcrumbs-daily';
    case FEATURES_SOURCE_MAP.EDITOR_CHOICE: return 'features-breadcrumbs-editors-choice';
    case FEATURES_SOURCE_MAP.EXTERNAL_PROMO: return 'features-breadcrumbs-external-promo';
    case SOURCES_MAP.NEWS: return 'dynamic-news-breadcrumbs';
    case SOURCES_MAP.POPUPS: return 'popups-breadcrumbs';
    case SOURCES_MAP.CATEGORIES: return 'categories-breadcrumbs';
    case SOURCES_MAP.COLLECTIONS: return 'collections-breadcrumbs';
    case SOURCES_MAP.LOCAL_NOTIFICATIONS: return 'local-notifications-breadcrumbs';
    case SOURCES_MAP.PUSH_NOTIFICATIONS: return 'push-notifications-breadcrumbs';
    case SOURCES_MAP.FILTERS: return 'filters-breadcrumbs';
    case SOURCES_MAP.FILTER_GROUPS: return 'filter-groups-breadcrumbs';
    case SOURCES_MAP.EVENTS: return 'events-breadcrumbs';
    case SOURCES_MAP.STICKERS: return 'stickers-breadcrumbs';

    default: return EMPTY_VALUE_PLACEHOLDER;
  }
};

export default getFeatureSourceTranslation;
